module.exports = __webpack_public_path__ + "img/img_4_1.3981684a.png";